import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SolicitudesComponent } from './components/solicitudes/solicitudes.component';
import { DashboardProfesionesComponent } from './components/dashboard-profesiones/dashboard-profesiones.component';
// Agrega más módulos que necesites...

import { RegistroProfesionalesRoutingModule } from './registro-profesionales-routing.module';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { SharedModule } from 'src/app/shared/shared.module';
import { Button, ButtonModule } from 'primeng/button';
import { PersonasTableComponent } from 'src/app/shared/components/personas-table/personas-table.component';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { TabViewModule } from 'primeng/tabview';
import { DividerModule } from 'primeng/divider';
import { StyleClassModule } from 'primeng/styleclass';
import { AutoFocusModule } from 'primeng/autofocus';
import { KeyFilterModule } from 'primeng/keyfilter';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { SidebarModule } from 'primeng/sidebar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { ProyectosModule } from '../proyectos/proyectos.module';

@NgModule({
    declarations: [SolicitudesComponent, DashboardProfesionesComponent],
    imports: [
        CommonModule,
        RouterModule,
        RegistroProfesionalesRoutingModule,
        ToastModule,
        CardModule,
        SharedModule,
        ButtonModule,
        ButtonModule,
        RippleModule,
        InputTextModule,
        DropdownModule,
        FormsModule,
        InputNumberModule,
        InputMaskModule,
        TabViewModule,
        DividerModule,
        ReactiveFormsModule,
        StyleClassModule,
        AutoFocusModule,
        KeyFilterModule,
        TooltipModule,
        MessagesModule,
        SidebarModule,
        ConfirmDialogModule,
        CheckboxModule,
        InputTextareaModule,
        AccordionModule,
        CalendarModule,
        PersonasTableComponent,
        ProyectosModule,
        

    ],
    exports: [DashboardProfesionesComponent, SolicitudesComponent],
})
export class RegistroProfesionalesModule {}
